// sagas/closureSaga.js
import { takeLatest, call, put } from "redux-saga/effects";
import api from "../../../services/api";
import {
  SUBMIT_OPERATIONS_SUPPLY_CHAIN_REQUEST,
  submitOperationsAndSupplyChainSuccess,
  submitOperationsAndSupplyChainFailure
} from "../actions/operationsAndSupplyChainActions";
import { fetchOperationsAndSupplyChain } from "../../../services/accIqService";

// Saga function
function* handleOperationsAndSupplyChainSubmission(action) {
  try {
    const response = yield call(
        fetchOperationsAndSupplyChain, 
        // action.payload.clientName, 
        // action.payload.accountName, 
        // action.payload.contact, 
        // action.payload.context,
        // action.payload.contextFile,
        // action.payload.outputFile,
        // action.payload.responseType
    );
    yield put(submitOperationsAndSupplyChainSuccess(response || "Operations and supply chains not generated."));
  } catch (error) {
    yield put(submitOperationsAndSupplyChainFailure(error.error));
  }
}

export function* watchOperationsAndSupplyChainSubmission() {
  yield takeLatest(SUBMIT_OPERATIONS_SUPPLY_CHAIN_REQUEST, handleOperationsAndSupplyChainSubmission);
}